// קומפוננטת UI בסיסית שמציגה שדה חיפוש עם כפתורי חיפוש וניקוי, והיא אחראית רק על הרינדור והעברת האירועים לקומפוננטת האב

import React from 'react';
import { Search, X } from 'lucide-react';

const SearchInput = ({
                         searchValue,
                         onSearchChange,
                         onSearch,
                         onClear,
                         onFocus,
                         variant = 'expandable',
                         placeholder
                     }) => {
    const inputStyles = {
        expandable: `
            w-full px-4 py-2.5 pr-10 pl-12
            bg-white/90 backdrop-blur-sm rounded-full
            border-2 border-[#D4B797]/40
            focus:border-[#8B5E3C] focus:outline-none
            focus:ring-2 focus:ring-[#8B5E3C]/20
            focus:bg-white
            transition-all duration-300
            font-heebo text-lg text-right
            placeholder:text-[#8B5E3C]/70
        `,
        standalone: `
            w-full p-4 rounded-xl border-2 border-[#e1ddd7] bg-white/90
            text-[#4a3f30] text-lg placeholder-[#937c5d]/60 font-heebo
            focus:outline-none focus:border-[#c9a66c] focus:ring-2 focus:ring-[#c9a66c]/20
            transition-all duration-300
        `
    };

    return (
        <div className="relative">
            <input
                type="text"
                value={searchValue}
                onChange={(e) => onSearchChange(e.target.value)}
                onFocus={onFocus}
                onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                        onSearch();
                    }
                }}
                placeholder={placeholder}
                className={`${inputStyles[variant]} ${searchValue ? 'pr-12' : 'pr-10'}`}
                style={{direction: 'rtl'}}
            />
            <Search
                className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-[#8B5E3C] cursor-pointer"
                onClick={onSearch}
            />

            {searchValue && (
                <button
                    onClick={onClear}
                    className="absolute right-1 top-1/2 -translate-y-1/2 p-1 rounded-full hover:bg-[#8B5E3C]/10 transition-all duration-200 group"
                    aria-label="נקה חיפוש"
                >
                    <X
                        className="w-5 h-5 text-[#8B5E3C] opacity-70 group-hover:opacity-100 transition-opacity"
                    />
                </button>
            )}
        </div>
    );
};

export default SearchInput;